import { render, staticRenderFns } from "./RobotList.vue?vue&type=template&id=64c5b18c"
import script from "./RobotList.vue?vue&type=script&lang=js"
export * from "./RobotList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports